// PERSISTED CONTRACT — these values are stored as-is in AccountManagement's App table and mirrored by
// location.proto and TouchTab.Promotion. Never renumber a member; only append.
export const AppType = {
  Pay: 0,
  OrderAndPay: 1,
  OrderAndPayDriveThru: 2,
  GuestPay: 3,
  GuestPayBYOD: 4,
  DualDisplay: 5,
  PaySDK: 6,
  // The guest-facing tablet on the table. Portrait or landscape, unlike DualDisplay which is always landscape.
  Tabletop: 7,
} as const;

export type AppType = (typeof AppType)[keyof typeof AppType];
